import type { MedRefillState } from '../types/medrefill.types';

export const initialState: MedRefillState = {
  collectionDetails: null,
  integratedRefillOptions: null,
  isEditSummary: false,
  isInvalidCollectionMode: false,
  commonNonSupportedCollectionModes: [],
  commonSupportedCollectionModes: [],
  originalPrescriptionDate: null,
  patientDetails: null,
  paymentInfo: {
    paymentInstructions: '',
    paymentModes: [],
  },
  prescribedMedications: null,
  prescriptionSummary: null,
  previousSavedData: null,
  selectedClinic: null,
  selectedInstitution: null,
  selectedMedOrderType: null,
  sheetDatas: [],
  sortFilterData: null,
  specialInstructions: '',
  submitMedRefill: {
    error: null,
    result: null,
  },
  topUpMedicationDetails: {
    reasonForTopUp: {
      elaboration: '',
      reason: '',
    },
    topUpMedicationList: [],
  },
};
